/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ProjectPriorityDropdown_project$ref: FragmentReference;
declare export opaque type ProjectPriorityDropdown_project$fragmentType: ProjectPriorityDropdown_project$ref;
export type ProjectPriorityDropdown_project = {|
  +id: string,
  +priorityLevel: ?{|
    +id: string,
    +name: ?string,
  |},
  +$refType: ProjectPriorityDropdown_project$ref,
|};
export type ProjectPriorityDropdown_project$data = ProjectPriorityDropdown_project;
export type ProjectPriorityDropdown_project$key = {
  +$data?: ProjectPriorityDropdown_project$data,
  +$fragmentRefs: ProjectPriorityDropdown_project$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPriorityDropdown_project",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PriorityLevel",
      "kind": "LinkedField",
      "name": "priorityLevel",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectType"
};
})();
// prettier-ignore
(node/*: any*/).hash = '7317d103179cd9270c54e6ecc395151d';

module.exports = node;
